module.exports = __webpack_public_path__ + "static/media/mid3.bc2cbe0c.webm";